import api from './api'

export const signUpStep = (step, values) => sessionStorage.setItem(step, JSON.stringify(values))

export const getDataFromStep = step => JSON.parse(sessionStorage.getItem(step))

export const postProfessional = values => api.post('/onboarding/professional/', values)

export const patchProfessional = values => api.patch('/onboarding/professional/', values)

export const deleteProfessionalCNPJ = () => api.delete('/onboarding/professional/')

export const getStep = () => api.get('/onboarding/professional/')

export const autoSearch = values => api.post('/auto_search/', values)
